<template>
    <v-img src="/images/santa.webp" alt="" class="d-block" />
</template>

<script>
export default {};
</script>